import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import './TodoWritePage.scss'
import HtmlEditor from '../../Components/Commons/HtmlEditor'
import moment from 'moment'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import FileItem from '../../Components/Intro/FileItem'
import { RoleStr, getThumbnailSVG } from '../../Components/Commons/Utils'

import { DatePicker } from 'antd'

function getTodayDate() {
    const date = new Date()
    const year = date.getFullYear()
    const month = ('0' + (1 + date.getMonth())).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)

    return year + '-' + month + '-' + day
}

const todayDate = getTodayDate()
const dateFormat = 'YYYY-MM-DD'
class TodoWritePage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            input: {
                title: '',
                content: '',
            },
            files: [],
            user: {
                group: '',
                name: '',
            },
            assignee: {
                group: '',
                name: '',
            },
            notifyUsers: [],
            dueDate: null,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadUser()
        this.loadProjects()
        if (this.props.match.params.id) {
            this.loadTodo()
        }
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/auth/me`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ user: res.data })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadProjects = () => {
        const { cookies } = this.props
        axios
            .get(`${BACKEND_HOST}/projects/${cookies.get('project')}/users/`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                let notifyUsers = []
                let noOwner = true
                for (let i = 0; i < res.data.length; i += 1) {
                    if (res.data[i].group === 'CLIENT' && res.data[i].status === 'ENABLED') {
                        this.setState({ assignee: res.data[i] })
                        notifyUsers.push(res.data[i]._id)
                        noOwner = false
                    }
                }

                if (noOwner) {
                    alert('가입된 건축주가 없습니다.')
                    this.props.history.push(`/todo`)
                    return
                }

                this.setState({ notifyUsers })
                console.log(notifyUsers)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadTodo = () => {
        axios
            .get(`${BACKEND_HOST}/rfis/${this.props.match.params.id}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.setState({ input: { title: res.data.title, content: res.data.content } })

                //날짜 입력
                const newYear = res.data.dueDate.substring(0, 4)
                const newMonth = res.data.dueDate.substring(5, 7)
                const newDay = res.data.dueDate.substring(8, 10)

                this.handleDueChange(moment(`${newYear}-${newMonth}-${newDay}`))

                this.setState({ files: res.data.files })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    addTodo = () => {
        if (this.state.input.title === '') {
            alert('제목을 입력해주세요')
            return
        } else if (this.state.dueDate === null) {
            alert('마감일을 선택해주세요')
            return
        } else if (this.state.input.content === '' || !this.state.input.content) {
            alert('내용을 입력해주세요')
            return
        }

        const files = this.state.files
        const finalFiles = files.map((file) => file._id)

        const { cookies } = this.props
        axios
            .post(
                `${BACKEND_HOST}/rfis/`,
                {
                    title: this.state.input.title,
                    content: this.state.input.content,
                    dueDate: moment(this.state.dueDate).format('YYYY-MM-DD'),
                    files: finalFiles,
                    project_id: cookies.get('project'),
                    assignee_id: this.state.assignee._id,
                    // notifyUsers: this.state.notifyUsers,
                    status: 'READY',
                },
                {
                    headers: {
                        Authorization: `bearer ${Auth.getToken()}`,
                    },
                }
            )
            .then((res) => {
                //console.log(res.data);
                //window.location.href = '/todo';
                this.props.history.push(`/todo`)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    modifyTodo = () => {
        if (this.state.input.title === '') {
            alert('제목을 입력해주세요')
            return
        } else if (this.state.dueDate === null) {
            alert('마감일을 선택해주세요')
            return
        } else if (this.state.input.content === '') {
            alert('내용을 입력해주세요')
            return
        }

        const files = this.state.files
        const finalFiles = files.map((file) => file._id)

        const { cookies } = this.props
        axios
            .patch(
                `${BACKEND_HOST}/rfis/${this.props.match.params.id}`,
                {
                    title: this.state.input.title,
                    content: this.state.input.content,
                    files: finalFiles,
                    dueDate: moment(this.state.dueDate).format('YYYY-MM-DD'),
                },
                {
                    headers: {
                        Authorization: `bearer ${Auth.getToken()}`,
                    },
                }
            )
            .then((res) => {
                //console.log(res.data);
                //window.location.href = '/todo';
                this.props.history.push(`/todo`)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    changeData = (event) => {
        const field = event.target.name
        const input = this.state.input
        input[field] = event.target.value

        this.setState({
            input,
        })
    }

    handleDueChange = (dueDate) => {
        console.log('dueDate', dueDate)
        this.setState({
            dueDate,
        })
    }

    handleModelChange = (model) => {
        const input = this.state.input
        input['content'] = model

        this.setState({
            input,
        })
    }

    deleteFile = (item) => {
        let newFiles = ''
        newFiles = this.state.files.filter((data) => data !== item)

        this.setState({
            files: newFiles,
        })
    }

    fileUpload = (e) => {
        e.preventDefault()

        const file = document.querySelector('input[id=file1]').files[0]
        const data = new FormData()
        data.append('file', file)
        data.append('isEnabled', 'false')
        data.append('metadataType', 'RFI_FILE_V1')

        axios
            .post(`${BACKEND_HOST}/files/upload-files`, data, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                const newFiles = [...this.state.files, ...res.data]

                this.setState({
                    files: newFiles,
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    FileList = (label) => {
        let files = ''
        files = this.state.files

        if (files.length === 0) {
            return (
                <label htmlFor={label} className="no_file_text">
                    파일을 첨부해주세요
                </label>
            )
        } else {
            const List = files.map((item) => {
                return <FileItem item={item} key={item.filename} deleteFile={this.deleteFile} />
            })
            return List
        }
    }

    render() {
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap section_wrap_menu">
                    <div className="todo_write_wrap common_detail">
                        <div className="section">
                            <div className="top_wrap">
                                <div className="page_name">건축주 할 일</div>
                                <input
                                    className="title_textarea"
                                    placeholder="제목을 입력하세요!"
                                    type="text"
                                    name="title"
                                    onChange={this.changeData}
                                    value={this.state.input.title}></input>
                                <ul>
                                    <li className="top_wrap_li">
                                        <p className="title title__min-width">요청자</p>
                                        <p className="content">
                                            {RoleStr[this.state.user.group]} {this.state.user.name}
                                        </p>
                                    </li>
                                    <li className="top_wrap_li">
                                        <p className="title title__min-width">처리자</p>
                                        <p className="content">
                                            {RoleStr[this.state.assignee.group]} {this.state.assignee.name}
                                        </p>
                                    </li>
                                    <li className="top_wrap_li">
                                        <p className="title title__min-width">마감일</p>
                                        <div className="date_picker single_date_picker">
                                            <DatePicker
                                                disabledDate={(d) => !d || d.isSameOrBefore(todayDate, 'day')}
                                                style={{
                                                    width: '150px',
                                                    backgroundColor: '#f6f8fb',
                                                    border: 'none',
                                                    padding: 0,
                                                }}
                                                size={'small'}
                                                placeholder="날짜를 선택하세요"
                                                onChange={(date, dateString) => {
                                                    this.handleDueChange(date)
                                                }}
                                                value={this.state.dueDate}
                                                defaultValue={this.state.dueDate}
                                                format={dateFormat}
                                            />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="file_input_wrap">
                                <div className="file_input">
                                    <div className="file_name">{this.FileList('file1')}</div>
                                    <label htmlFor="file1" className="load_btn">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14"
                                            height="14"
                                            viewBox="0 0 14 14">
                                            <path
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#A2A7AE"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="1.3"
                                                d="M12.9 6.632l-5.484 5.643a3.512 3.512 0 0 1-5.067 0C.95 10.835.95 8.502 2.35 7.062L7.834 1.42a2.341 2.341 0 0 1 3.377 0c.933.96.933 2.515 0 3.475l-5.49 5.642a1.17 1.17 0 0 1-1.689 0 1.254 1.254 0 0 1 0-1.737L9.1 3.593"
                                            />
                                        </svg>
                                        <p>파일 첨부</p>
                                    </label>
                                    <input id="file1" type="file" onChange={(e) => this.fileUpload(e)} />
                                </div>
                            </div>

                            <HtmlEditor content={this.state.input.content} handleModelChange={this.handleModelChange} />

                            <div className="btn_wrap">
                                <Link to={`/todo/`}>
                                    <div className="cancel_btn">취소</div>
                                </Link>
                                <div
                                    className="ok_btn"
                                    onClick={this.props.match.params.id ? this.modifyTodo : this.addTodo}>
                                    등록
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(TodoWritePage)



// WEBPACK FOOTER //
// ./Src/Containers/Todo/TodoWritePage.js